import React from 'react';
import WorkspaceGuideDialog from '../../../shared/ui/common/WorkspaceGuideDialog';
import type { WorkspaceIntroCardProps } from '../../../shared/ui/common/WorkspaceIntroCard';

interface QuickFillGuideDialogProps {
  open: boolean;
  onClose: () => void;
  onStartTour: () => void;
  content: WorkspaceIntroCardProps;
}

const QuickFillGuideDialog: React.FC<QuickFillGuideDialogProps> = ({
  open,
  onClose,
  onStartTour,
  content,
}) => (
  <WorkspaceGuideDialog
    open={open}
    onClose={onClose}
    dialogTitle="Quick Fill guide window"
    onAction={onStartTour}
    {...content}
  />
);

export default QuickFillGuideDialog;
